import { RequestService } from '../../../../../common/services/RequestService';
import { API_TARIFF_PRICE } from '../../constants';

export const getTariffPriceRequest = payload => {
  return RequestService.get(
    API_TARIFF_PRICE +
      `?tariff_type_id=${payload.tariffTypeId}&tariff_fee_period_id=${payload.tariffFeePeriodId}`
  ).then(response => response);
};
